module.exports = __webpack_public_path__ + "static/media/stek-min.b189cccb.png";